module.exports = __webpack_public_path__ + "img/garage.607fd21.svg";